export default __webpack_public_path__ + "static/media/document.8be740b6.svg";